import React, { useEffect } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import Button from "modules/Common/Components/Button";
import Roy from "../../../../assets/img/icons/roy.svg";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { LIST_IMPORT } from "constants/actionTypes";
import Cross from "../../../../assets/img/icons/cross.svg";
import { addGillRoyIcon } from "utils";

interface AppProps {
  hide?: boolean;
  listId: number;
  importedContacts: number;
  setShowImportCompleteAsider: any;
  closeHeaderSiderOverlays: any;
}

const FloatingPopoverComplete: React.FC<AppProps> = ({
  hide = false,
  listId,
  importedContacts,
  setShowImportCompleteAsider,
  closeHeaderSiderOverlays,
}) => {
  const history = useHistory();
  const display = useSelector((state: RootState) => state.uiReducer.overlay);
  function handleViewList() {
    setShowImportCompleteAsider(false);
    let queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('list_id') && queryParams.get('list_id')?.toString() === listId.toString()) {
      // queryParams.delete('list_id');
      history.replace(window.location.pathname + "?" + queryParams.toString())
    } else {
      queryParams.delete('list_id');
      queryParams.append('list_id', listId.toString());
      // history.push(`/audiences/view?${queryParams.toString()}`);
      history.push(`/audiences/lists/view?${queryParams.toString()}`);
    }
    document.querySelector("body").style.overflow = "auto";
    addGillRoyIcon()
  }
  // useEffect(() => {
  //   if (history.location.pathname !== "/audiences/lists") setShowImportCompleteAsider(false);
  // }, [history.location.pathname]);

  const handleClose = () => {
    setShowImportCompleteAsider(false);
    if (closeHeaderSiderOverlays) closeHeaderSiderOverlays();
    addGillRoyIcon()
  };

  useEffect(() => {
    store.dispatch({ type: LIST_IMPORT.CLOSE });
  }, []);

  return (
    <Wrapper>
      <span className="cross" onClick={handleClose}>
        <img src={Cross} alt="" />
      </span>
      <div>
        <img src={Roy} alt="" />
        <h2>
          Import <br />
          complete!
        </h2>
        <p>
          {importedContacts} contacts have been imported, time to start building better relationships with your
          accounts, customers and prospects!
        </p>
        <Button value="View List" onClick={() => handleViewList()} />
      </div>
    </Wrapper>
  );
};

export default FloatingPopoverComplete;

const Wrapper = styled.div`
  > div {
    padding: 75px 35px 75px 35px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 35px 30px 35px 30px;
    }
    h2 {
      margin-top: 20px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 28px !important;
        line-height: 28px !important;
      }
    }
  }
  .cross {
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .cross > img {
    width: auto;
  }
`;
